import { apiGetData } from '../../../../core/utils/api/generic'
import { TransmissionType } from '../../../../types/Transmissions/Transmission'

export const getTranmsissions = (entity: string, entityId: string) =>
  apiGetData<{ data: TransmissionType }>(`/integrations/transmissions/${entity}/${entityId}`)

export default {}
